var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grapes-doc-editor" }, [
    _c("div", { ref: "gjs", staticClass: "grapes-doc-editor__canvas" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }